const snackbarInitialState = {
  snackbarOpen: false,
  snackbarType: '',
  snackbarMessage: '',
  vertical: 'top',
  horizontal: 'center',
};
export default snackbarInitialState;
